import React, { useState } from 'react';
import "./careersection.css";
import Popupboxbox from '../popupbox/Popupbox';

function Careersection() {
  const [showModal, setShowModal] = useState(false); 
  return (
    <>
    <section className="career-banner">
      {/* Dark overlay layer to ensure text readability over the background image */}
      <div className="banner-overlay">
        <div className="banner-content">
          <h2 className="banner-title">
            Change your career From Non-IT to IT
          </h2>
          <p className="banner-subtitle">
            We are here to help you to get a career in IT
          </p>
          <button className="banner-btn"  onClick={() => setShowModal(true)}>
            Contact Us
          </button>
        </div>
      </div>
    </section>
          <Popupboxbox isOpen={showModal} onClose={() => setShowModal(false)} />

    </>
  );
}

export default Careersection;